import { Grid } from '@material-ui/core';
import { DateTimePicker, Dialog, Typography } from 'components';
import moment from 'moment';
import React from 'react';

const FilterDateDialog = ({
  openFilterDate,
  filterStartDate,
  filterEndDate,
  setOpenFilterDate,
  setFilterStartDate,
  setFilterEndDate,
}) => {
  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={openFilterDate}
      onClose={() => {
        setOpenFilterDate(false);
      }}
      action={{
        label: 'Reset',
        onClick: () => {
          setFilterStartDate('');
          setFilterEndDate('');
          setOpenFilterDate(false);
        },
      }}
      title="Filter Hari Libur"
    >
      <Grid container spacing={2} style={{ marginBottom: 16 }}>
        <Grid item xs={6}>
          <Typography variant="body1" type="bold" style={{ marginBottom: 4 }}>
            Dari
          </Typography>
          <DateTimePicker
            dateOnly
            value={filterStartDate}
            onChange={(value) => setFilterStartDate(moment(value).startOf('day').valueOf())}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body1" type="bold" style={{ marginBottom: 4 }}>
            Sampai
          </Typography>
          <DateTimePicker
            dateOnly
            minDate={filterStartDate}
            value={filterEndDate}
            onChange={(value) => setFilterEndDate(moment(value).endOf('day').valueOf())}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default FilterDateDialog;
